
































































import Vue from 'vue'
import Page from '@/components/layouts/Page.vue'
import ClientFlowAPi from '@/api/clientFlow'
import { toPrettyJson } from '@/lib/utils/toPrettyJson'

type ResponseError = Error | undefined

export default Vue.extend({
  name: 'ApiTest',

  components: {
    Page,
  },
  props: {
  },
  data: () => ({
    pingIsLoading: false,
    pingResult: '',
    sayHiIsLoading: false,
    sayHiResult: '',
    sayHiError: undefined as ResponseError,
    showSayHiError: false,
  }),
  computed: {

    formattedSayHiError(): string {
      return toPrettyJson(this.sayHiError)
    },
  },
  methods: {
    async ping() {
      this.pingIsLoading = true
      this.pingResult = ''
      const response = await ClientFlowAPi.ping()
      this.pingResult = `${response.status}: ${response.message}`
      this.pingIsLoading = false
    },
    async sayHi() {
      this.sayHiIsLoading = true
      this.sayHiResult = ''
      this.sayHiError = undefined
      const resp = await ClientFlowAPi.sayHi('superman')
      if (resp.isOk()) {
        this.sayHiError = undefined
        this.sayHiResult = resp.value
      } else {
        this.sayHiResult = resp.error.message
        this.sayHiError = resp.error
      }
      this.sayHiIsLoading = false
    },
  },
})
